import React, { useMemo } from "react";
import { generateRecurringDates } from "./WizardConstants";

export function WizardStepReview({ form, stepIssues }) {
  const issues = useMemo(() => stepIssues(), [stepIssues]);
  const filteredDeliverables = useMemo(() => form.deliverables.filter(d => d.description), [form.deliverables]);
  const filteredKpis = useMemo(() => form.kpis.filter(k => k.description), [form.kpis]);

  return (
    <div className="space-y-4" data-testid="wizard-step-review-content">
      <div>
        <h2 className="text-lg font-medium">Review & Save</h2>
        <p className="text-sm text-slate-500 mt-1">Check everything looks right before creating the contract.</p>
      </div>

      {issues.length > 0 && (
        <div className="border border-amber-200 bg-amber-50/50 rounded-sm p-3 space-y-1" data-testid="wizard-issues">
          <p className="text-sm font-medium text-amber-700">Missing required fields:</p>
          {issues.map(issue => (
            <p key={issue} className="text-sm text-amber-600 flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />{issue}
            </p>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="space-y-3 border rounded-sm p-3">
          <p className="text-xs font-mono uppercase text-slate-500">Contract</p>
          <div><span className="text-slate-400">Title: </span><span className="font-medium">{form.title || "\u2014"}</span></div>
          <div><span className="text-slate-400">Type: </span>{form.contract_type || "\u2014"}</div>
          <div><span className="text-slate-400">Value: </span>{form.contract_value ? `${form.currency || ""} ${Number(form.contract_value).toLocaleString()}` : "\u2014"}</div>
          <div><span className="text-slate-400">Period: </span>{form.effective_date || "\u2014"} to {form.expiration_date || "\u2014"}</div>
          <div><span className="text-slate-400">Department: </span>{form.department || "\u2014"}</div>
          <div><span className="text-slate-400">Category: </span>{form.spend_category || "\u2014"}</div>
        </div>
        <div className="space-y-3 border rounded-sm p-3">
          <p className="text-xs font-mono uppercase text-slate-500">Supplier</p>
          <div><span className="text-slate-400">Name: </span><span className="font-medium">{form.contracting_party.legal_name || "\u2014"}</span></div>
          <div><span className="text-slate-400">Address: </span>{form.contracting_party.registered_address || "\u2014"}</div>
          <div><span className="text-slate-400">Email: </span>{form.contracting_party.contact_email || "\u2014"}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="border rounded-sm p-3">
          <p className="text-xs font-mono uppercase text-slate-500 mb-2">Deliverables ({filteredDeliverables.length})</p>
          {filteredDeliverables.length === 0 ? (
            <p className="text-slate-400 text-xs">None added</p>
          ) : (
            <ul className="space-y-1">{filteredDeliverables.map((d, i) => (
              <li key={`rev-d-${i}`} className="text-xs text-slate-600">
                - {d.description}
                {d.recurrence && d.recurrence !== "once" && (
                  <span className="text-violet-600 ml-1">
                    ({d.recurrence}{d.delivery_date ? `, from ${d.delivery_date}` : ""}{d.delivery_date ? `, ${generateRecurringDates(d.delivery_date, d.recurrence, d.recurrence_end || form.expiration_date).length} occurrences` : ""})
                  </span>
                )}
                {(!d.recurrence || d.recurrence === "once") && d.delivery_date && (
                  <span className="text-slate-400 ml-1">({d.delivery_date})</span>
                )}
              </li>
            ))}</ul>
          )}
        </div>
        <div className="border rounded-sm p-3">
          <p className="text-xs font-mono uppercase text-slate-500 mb-2">KPIs ({filteredKpis.length})</p>
          {filteredKpis.length === 0 ? (
            <p className="text-slate-400 text-xs">None added</p>
          ) : (
            <ul className="space-y-1">{filteredKpis.map((k, i) => (
              <li key={`rev-k-${i}`} className="text-xs text-slate-600">- {k.description} ({k.measure || "no measure"})</li>
            ))}</ul>
          )}
        </div>
      </div>

      {form.template_id && (
        <p className="text-xs text-slate-400">Using template with {form.sections.length} sections. You can edit content in the full editor after creation.</p>
      )}
    </div>
  );
}
